import React, { Component } from "react"
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { ParentGeneral } from "./ParentGeneral"
import { ParentEmployment } from "./ParentEmployment" 
import { ParentNotEmployed } from "./ParentNotEmployed" 
import { ParentEmployHistory } from "./ParentEmployHistory" 
import { ParentEmployBoz } from "./ParentEmployBoz" 
import { ParentEducation } from "./ParentEducation" 
import { ParentDiploma } from "./ParentDiploma" 
import { ParentHealth } from "./ParentHealth" 
import { ParentHealthStatus } from "./ParentHealthStatus" 
// import { ParentQuestionnaire, questionnareFields } from "./ParentQuestionnaire"
import { ParentQuestionnairePre, questionnareFields } from "./ParentQuestionnairePre"
import { digmaDate } from "../Tree/Utils.js"
import {GetParentsEP } from "../../variables/Config"
import YSpinner from '../../elements/Spinner/Spinner'

/* 
  Getting info from parent CPT to break network overload (not from family cpt)
  Input: family cpt id or even better parent cpt id, all generated at refrral -> family event
  parentCptId <- familyCPT[parent-woman/man] 

*/
// import 'react-tabs/style/react-tabs.css' 
export class FamilyParent extends Component {
    constructor(props){
        super(props)
        this._isMounted = false;
        this.state = {
            isLoading: true, // was false
            isParentUpdate: false,
            restError: "",
            periodic_questionnaire: [], // repeater (array) of objects { {id: & bench_stat: {all answers}}}
            cpt:{}
        }
        this.handleRowDel   = this.handleRowDel.bind(this)
        this.handleAddEvent = this.handleAddEvent.bind(this)
        this.onEditCellTable = this.onEditCellTable.bind(this)
        this.onSaveToDB = this.onSaveToDB.bind(this)
        this.onAddQuestionnaire = this.onAddQuestionnaire.bind(this)
        this.onParentUpdate = this.onParentUpdate.bind(this)
        this.inUpdate = this.inUpdate.bind(this)

    }
    inUpdate(onOff){
        console.log("inUpdate =", onOff)
        if (this._isMounted)
            this.setState({isUpdating:onOff})
    }
    onParentUpdate(onOff){
        if (this._isMounted)
            this.setState({isParentUpdate:onOff})
    }
    fetchTerm(url) {
        fetch(url/*, { signal: this.abortController.signal }*/)
        .then(response => {
            if (!this._isMounted) return null
            if (response.ok)
                return response.json()
            throw new Error('fetchTerm: Something went wrong ...')
        })
        .then(cpt => {             
            var terms = cpt['acf']
            let periodic_questionnaire = terms['periodic_questionnaire']
            /*let parent_info = terms['parent_info']
            let parent_hstatus = terms['parent_hstatus']
            let parent_employment = terms['parent_employment']
            let parent_notemployed = terms['parent_notemployed']
            let parent_education = terms['parent_education']
            let parent_diploma = terms['parent_diploma']
            let health_issues = terms['health_issues']
            let parent_employ_history = terms['parent_employ_history']
            let parent_employ_boz = terms['parent_employ_boz']
            let questionnaire_pre = terms['questionnaire_pre']
            let questionnaire_post = terms['questionnaire_post']*/
            //console.log("fetch:cpt", cpt)
            if (!this._isMounted) return null
            this.setState({cpt, periodic_questionnaire, /*parent_info, parent_employment, parent_education, parent_employ_history, questionnaire_pre, 
                questionnaire_post, parent_diploma, parent_notemployed, parent_hstatus, parent_employ_boz,
                    health_issues,  terms,*/ isLoading: false}) // , isLoading:false}) // ,() => console.log("FamilyLogs: ", cpt))
           
            return (terms) // void - no one is looking...
        })
        .catch(restError => {
            if (!this._isMounted) return null
            if (restError.name === 'AbortError') return; 
            this.setState({ restError: restError, isLoading: false })
        })
        return null
    }
    
    componentDidMount(){ // add constructor..
        this._isMounted = true
        this.setState({  isLoading: true  })     // modalRoot: document.getElementById('modal-root'),
        //var uri = "http://yahav/wp-json/wp/v2/digma_parents/"+this.props.memberPostId+"?fields=id,title,acf"GetParentsEP
        const uri = GetParentsEP() + "/" + this.props.memberPostId + "?fields=id,title,acf"
        this.fetchTerm(uri)
    }
    componentWillUnmount(){ // add constructor..
        this._isMounted = false
    }

    handleRowDel(term, tabindex) {
        let ti = parseInt(tabindex) - 1
        let ct = this.state.terms
        // array = Object.Assign(this.state.terms) - to keep immutability
        var index = ct[ti]["familywp_main_taskarray"].indexOf(term)
        if (index !== -1)
            return console.log("Family parent handleRowDel: " + term + " not found")
            
        ct[ti]['familywp_main_taskarray'].splice(index, 1)
        this.setState({terms:ct})
    }
    
    handleAddEvent(tableId) { // add row event
        // console.log("handleAddEvent-tableId", tableId-1)
        var id = (+ new Date() + Math.floor(Math.random() * 999999)).toString(36);
        let d = digmaDate(Date())
        var row = {
          id: id,
          familywp_taskarray_task: "",
          familywp_taskarray_description:"",
          familywp_taskarray_responsible:"",
          familywp_taskarray_startdate: d,
          familywp_taskarray_duedate: "",
          familywp_taskarray_status: "",
          familywp_taskarray_needsolution:"" // link to needsolution table
        }
        let ct = this.state.terms
        ct[tableId-1]['familywp_main_taskarray'].unshift(row)
        this.setState({terms:ct})
    }
    generateQlist(flist){
        for (const key in questionnareFields) {
          // console.log("questionnareFields: key="+key+" m[k]= "+ questionnareFields[key])
          let item = {
            type: "text",
            name: key,
            value: "", // product[key],
            id: "", // product.id,
            edit: true
          }
          if (key[0] === 'q' && '0123456789'.indexOf(key[1]) !== -1) {
            item.type = "select"
            item.options = ["1-כלל לא", "2-במידה מועטה מאוד", "3- במידה מועטה","4-במידה בינונית", "5-במידה רבה", "6-במידה רבה מאוד"]
            if (key[1] === 1 && key.length <= 2)
              item.newsection= 'באיזו מידה המשפטים הבאים מתארים את ההרגשה שלך?'
          } else if ((key[0] === 's' || key[0] === 'r') && '0123456789'.indexOf(key[1]) !== -1) {
            item.type = "select"
            item.options = ["1-כלל לא", "2-מעטה", "3-בינונית", "4-רבה", "5-רבה מאוד"]
            if (key[1] === 1 && key.length <= 2){
              if (key[0] === 's') 
                item.newsection= 'באיזו מידה את/ה מרוצה מהדברים הבאים?'
              else
                item.newsection= 'איך היית מדרג/ת את הדברים הבאים?'
            }
  
          } else if (key === "comments") {
            item.type = "textarea"
            //item.style = '{width: "300px"}'
          }
          flist.push(item)
        }
       
    }
    onAddQuestionnaire(evt){
        // generate new questionnaire in this.state
        // setState to render the new guy
        // make sure that no more than 4 questionnairs are present
        evt.preventDefault()
        if (!this._isMounted){
            //////console.log("onAddQuestionnaire - _isMounted =", this._isMounted )
            return
        }
        var flist = []
        //////console.log("onAddQuestionnaire - questionnareFields =", questionnareFields)
        if (typeof this.state.periodic_questionnaire === "undefined" || !this.state.periodic_questionnaire.length){
            this.generateQlist(flist) // modify flist
// var tmp = Object.assign(this.state.periodic_questionnaire)
        //tmp.push(flist)
        //this.setState({periodic_questionnaire: tmp})
        this.setState({periodic_questionnaire: {flist}}) // , terms:flist
            
            //////console.log("onAddQuestionnaire - flist =", flist)
            // add first questionnaire
        } else if (this.state.periodic_questionnaire.length < 4){
            // add next questionnaire
        } // else hide the ADD button

    }

    onEditCellTable(tableId, item){

        //console.log("onEditCellTable item", item)
        //console.log("onEditCellTable tableId", tableId-1)
        //console.log("onEditCellTable terms[tableId-1]", this.state.terms[tableId-1])
        let products = Object.assign(this.state.terms[tableId-1]['familywp_main_taskarray']) // copy table
        //console.log("onEditCellTable products", products)

        //var products = this.state.products.slice();
        //var products = ct.slice();
        // console.log("products-EVT", products);

        var newProducts = products.map(function(product) { // new task array 1 of 3...

            for (var key in product) {
                if (key === item.name && product.id === item.id) {
                    product[key] = item.value
                }
            }
            return product
        })
        //console.log("onEditCellTable newProducts", newProducts)

        let allTerms = Object.assign(this.state.terms) // copy table
        allTerms[tableId-1]['familywp_main_taskarray'] = newProducts
        
        this.setState({terms:allTerms})
    }
    onSaveToDB(cptId, data, dataId, dataType){
        //const data = this.state.terms
        //const cptId = this.props.memberPostId
        //const dataId = this.props.subTableId // "familywp_mainarray"; subTableId = {"familywp_mainarray"} 
        //const dataType = "table" // no need for MultiTable
        //onSaveSubTable(cptId, data, dataId, dataType)

        this.props.save2DB(cptId, data, dataId, dataType, this.props.inUpdate)
        // console.log("Family Parent onSaveToDB: cptId" + cptId + " dataId = " + dataId+ " dataType = " + dataType + " data=", data)
        // this.props.save2DB(cptId, data, dataId, dataType)
        // saveSubAcf2DB(cptId, data, dataId, dataType)
    }                          
    
    render(){
        if (this.state.isLoading)
            return <YSpinner />
        if (this.state.restError !== "")
            return <h2>תקלה חולפת: {this.state.restError}</h2>
        const terms = this.state.cpt['acf']
        const parent_info = terms['parent_info']
        const parent_hstatus = terms['parent_hstatus']
        const parent_employment = terms['parent_employment']
        const parent_notemployed = terms['parent_notemployed']
        const parent_education = terms['parent_education']
        const parent_diploma = terms['parent_diploma']
        const health_issues = terms['health_issues']
        const parent_employ_history = terms['parent_employ_history']
        const parent_employ_boz = terms['parent_employ_boz']
        //const periodic_questionnaire = terms['periodic_questionnaire']
        const questionnaire_pre = terms['questionnaire_pre']
        const questionnaire_post = terms['questionnaire_post']

        
       
        return (
            <Tabs className="float-right">
                {this.state.isUpdating ? <YSpinner message={"מעדכן..."} /> : null }
                <TabList>
                    <Tab>נתונים כלליים</Tab>
                    <Tab>תעסוקה</Tab>
                    <Tab>השכלה</Tab>
                    <Tab>בריאות</Tab>
                    <Tab>שאלוני עמדות</Tab>
                </TabList>
                <TabPanel>
                    <ParentGeneral tableTitle={"נתונים כלליים"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_info}
                        subTableId = {"parent_info"}
                        inUpdate = {this.onParentUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                </TabPanel>
                <TabPanel>
                    <ParentEmployment tableTitle={"נתוני תעסוקה"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_employment}
                        subTableId = {"parent_employment"}
                        inUpdate = {this.inUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                    <br />
                    <ParentEmployBoz tableTitle={"עבודות נוספות במקביל"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_employ_boz}
                        subTableId = {"parent_employ_boz"}
                        inUpdate = {this.inUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                    <br />
                    <ParentNotEmployed tableTitle={"בלתי מועסקים"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_notemployed}
                        subTableId = {"parent_notemployed"}
                        inUpdate = {this.inUpdate}
                        save2DB = {this.onSaveToDB} 
                    />                     
                    
                    <br />
                    <ParentEmployHistory tableTitle={"הסטוריה תעסוקתית"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_employ_history}
                        subTableId = {"parent_employ_history"}
                        inUpdate = {this.inUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                </TabPanel>
                               
                <TabPanel>
                    <ParentEducation tableTitle={"נתוני השכלה"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_education}
                        subTableId = {"parent_education"}
                        inUpdate = {this.onParentUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                    <ParentDiploma tableTitle={"הכשרות נוספות"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_diploma}
                        subTableId = {"parent_diploma"}
                        inUpdate = {this.onParentUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                    
                </TabPanel>
                <TabPanel>
                    <ParentHealthStatus tableTitle={"מצב רפואי"} 
                        memberPostId={this.props.memberPostId} 
                        data={parent_hstatus}
                        subTableId = {"parent_hstatus"}
                        inUpdate = {this.onParentUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                    <br />
                    <ParentHealth tableTitle={"בעיות בריאות"} 
                        memberPostId={this.props.memberPostId} 
                        data={health_issues}
                        subTableId = {"health_issues"}
                        inUpdate = {this.onParentUpdate}
                        save2DB = {this.onSaveToDB} 
                    />
                </TabPanel>
                <TabPanel>               
                    <Tabs className="float-right" >     
                        <TabList>
                            <Tab>{"תחילת התכנית"}</Tab>
                            <Tab>{"סיום התכנית"}</Tab>
                        </TabList>
                        <TabPanel>
                            <ParentQuestionnairePre tableTitle={"שאלון עמדות בתחילת התכנית"} 
                                        memberPostId={this.props.memberPostId} 
                                        data={questionnaire_pre}
                                        subTableId = {"questionnaire_pre"}
                        // inUpdate = {this.inUpdate}
                        inUpdate = {this.onParentUpdate}
                                        save2DB = {this.onSaveToDB}
                            />
                        </TabPanel>
                        <TabPanel>
                            <ParentQuestionnairePre tableTitle={"שאלון עמדות בסיום התכנית"} 
                                        memberPostId={this.props.memberPostId} 
                                        data={questionnaire_post}
                                        subTableId = {"questionnaire_post"}
                                    // inUpdate = {this.inUpdate}
                                    inUpdate = {this.onParentUpdate}
                                        save2DB = {this.onSaveToDB}
                            />
                        </TabPanel>

                    </Tabs>
                </TabPanel>
            </Tabs>
        )    
    }
}
